@if (hasNotificationsToShow | async) {
  <div class="notification-flash">
    @for (notification of notifications | async; track notification) {
      <ftr-alert [type]="notification.type" class="block my-4" [renderAsMarkdown]="true">
        {{ notification.message }}
      </ftr-alert>
    }
  </div>
}
